import { GET_STORAGE_COUNT } from 'actions/types';

const initialState = {
  storages: { count: 0, package_total: 0 },
  warehouses: { count: 0, package_total: 0 },
};
export function storageCount(state = initialState, action) {
  const { type, payload } = action;
  if (type === `${GET_STORAGE_COUNT}_SUCCESS`) {
    return payload;
  }
  return state;
}
